<h2 class="notion-heading-2 px-[16px] mt-[16px] mb-[8px]">
  @for(c of data.heading_2.rich_text; track $index) {
  <app-notion-text-component [data]="c"></app-notion-text-component>
  }
</h2>
